import { api, authApi } from './client';

const ACCEPT_JSON = { 'Accept': 'application/json' };

export const getProducts = ({ fecha_creacion, fecha_resolucion, current_pedido_id }) =>
    api.get('/productos/', { headers: ACCEPT_JSON, params: { fecha_creacion, fecha_resolucion, current_pedido_id } });

export const getAdminProducts = () =>
    authApi.get('/admin/productos/', { headers: ACCEPT_JSON });

export const createProduct = formData =>
    authApi.post('/crea-productos/', formData, { headers: { 'Content-Type': 'multipart/form-data' } });

export const updateProduct = (id, productData) =>
    authApi.put(`/admin/productos/${id}/`, productData);

export const deleteProduct = id =>
    authApi.delete(`/admin/productos/${id}/`);
